import {BindingDriftReport} from '../types';

// FNP-585: a run "needs attention" when repairs FAILED or the per-run repair cap was
// hit — the same conditions that page an operator (BindingRepairFailed /
// BindingDriftRepairCapped alarms). A human must see this without reading CloudWatch.
export const runNeedsAttention = (
    record: Pick<BindingDriftReport, 'repairFailedCount' | 'repairCappedCount'>,
): boolean =>
    (record.repairFailedCount ?? 0) > 0 || (record.repairCappedCount ?? 0) > 0;
